import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Chip,
} from '@mui/material';
import { ArrowForward, CalendarToday, Person } from '@mui/icons-material';
import { getPublicBlogs, getImageUrl } from '../../services/api';

const BlogSection = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await getPublicBlogs({ limit: 3 });
      setBlogs(response.data.data);
    } catch (error) {
      console.error('Failed to fetch blogs:', error);
    }
  };

  // const handleReadMore = (slug) => {
  //   navigate(`/blog/${slug}`);
  // };

  const scrollToBlogs = () => {
    const element = document.getElementById('blogs');
    if (element) {
      const headerOffset = 120;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    } else {
      navigate('/');
      setTimeout(() => {
        const target = document.getElementById('blogs');
        if (target) {
          const headerOffset = 120;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <Box id="blogs" sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 6 }}>
          <Box>
            <Typography
              variant="h2"
              sx={{ fontSize: { xs: '1.8rem', md: '2.5rem' } }}
            >
              Latest{' '}
              <Box component="span" sx={{ color: 'secondary.main' }}>
                Blogs
              </Box>
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Insights and updates on medical education
            </Typography>
          </Box>
          <Button
            variant="outlined"
            color="secondary"
            endIcon={<ArrowForward />}
            onClick={scrollToBlogs}
            sx={{ display: { xs: 'none', sm: 'flex' } }}
          >
            View All Blogs
          </Button>
        </Box>

        <Grid container spacing={4}>
          {blogs.map((blog) => (
            <Grid item xs={12} sm={6} md={4} key={blog._id}>
              <Card 
                sx={{ 
                  height: '100%', 
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.1)',
                  },
                }}
                // onClick={() => handleReadMore(blog.slug)}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={getImageUrl(blog.featuredImage) || 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400'}
                  alt={blog.title}
                />
                <CardContent>
                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <CalendarToday sx={{ fontSize: 14, color: 'text.secondary' }} />
                      <Typography variant="caption" color="text.secondary">
                        {new Date(blog.createdAt).toLocaleDateString()}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Person sx={{ fontSize: 14, color: 'text.secondary' }} />
                      <Typography variant="caption" color="text.secondary">
                        {blog.author}
                      </Typography>
                    </Box>
                  </Box>
                  <Chip
                    label={blog.category}
                    size="small"
                    color="secondary"
                    sx={{ mb: 2 }}
                  />
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                    {blog.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {blog.excerpt}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   handleReadMore(blog.slug);
                    // }}
                  >
                    Read More
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ textAlign: 'center', mt: 4, display: { xs: 'block', sm: 'none' } }}>
          <Button
            variant="outlined"
            color="secondary"
            endIcon={<ArrowForward />}
            onClick={scrollToBlogs}
          >
            View All Blogs
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default BlogSection;